<template>
  <ThemeECommerceContainerSection
    :title="modelValue.title"
    :description="modelValue.description"
    :see-more-path="getPath({ componentName: 'Promotion' })"
    :menu-code="MENU_CODE.PROMOTION"
    :event-name="eventName"
    category-event-name=""
    class="tw-bg-light-gray-1"
  >
    <div class="tw-flex tw-overflow-x-auto md:tw-grid md:tw-grid-cols-2 lg:tw-grid-cols-4 tw-gap-4 md:tw-gap-6 tw-pb-4 md:tw-pb-0 tw-px-4 md:tw-px-0 -tw-mx-4 md:tw-mx-0">
      <div
        v-for="item in props.modelValue.content"
        :key="item._id"
        class="tw-min-w-[60vw] tw-max-w-[340px] md:tw-min-w-0 md:tw-max-w-none tw-mb-2"
      >
        <ThemeECommerceCardPromotion
          title-tag="h3"
          class="tw-scroll-smooth"
          :image="item.imageCover"
          :title="item.title"
          :description="item.description"
          :path="getPath({ componentName: 'Promotion', slug: item.slug})"
          :price="item.price"
          :price-of-discounted="item.priceOfDiscounted"
          :options="item.options"
          :show-option-list="false"
          :max-price-option="item.maxPriceOption"
          :min-price-option="item.minPriceOption"
          :min-price-of-discounted-option="item.minPriceOfDiscountedOption"
          :max-price-of-discounted-option="item.maxPriceOfDiscountedOption"
          :recommended="item.recommended"
          @click="eventHomePromotion(item.title)"
        />
      </div>
    </div>
  </ThemeECommerceContainerSection>
</template>

<script lang="ts" setup>
const props = defineProps({
  modelValue: {
    type: Object as () => HomeSection<Promotion[]>,
    required: true,
  },
})

const { MENU_CODE, eventName, eventHomePromotion, getPath } = usePromotionSection()
</script>
